import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CaptchaService from "../services/captcha.service";
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from '../common/with-router';
import {isEmail} from "validator";
const KEY_CAPTCHA = process.env.REACT_APP_KEY_CAPTCHA;
const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                Champ obligatoire!
            </div>
        );
    }
};

const email = value => {
    if (!isEmail(value)) {
        return (
            <div className="alert alert-danger" role="alert">
                Email non valide.
            </div>
        );
    }
};
class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeCaptcha = this.onChangeCaptcha.bind(this);

        this.state = {
            email: "",
            loading: false,
            KEY_CAPTCHA:KEY_CAPTCHA,
            cliccaptcha:false,
            resEmail:false,
            message:"",
            error:false
        };
    }
    onChangeCaptcha(value) {
        this.setState({loading:true})
        CaptchaService.validCaptchaUpdate(value,this.state.email).then(
            response => {
                this.setState({resEmail:false});
                if(response.data.success===true){
                    this.setState({cliccaptcha:true, loading:false});
                    this.setState({
                        message: "Merci de consulter votre email et cliquer sur lien pour modifier votre mot de passe.",
                    });
                }else{
                    if(response.status===204){
                        this.setState({
                            message: "Vous n'avez pas de compte avec cette adresse email, merci de vérifier votre adresse email.",
                            error:true,
                            loading:false,
                        });
                    }else {
                        this.setState({cliccaptcha: false, message: ""});
                    }
                }

            },
            error => {
                this.setState({resEmail:false});
                this.setState({cliccaptcha: false, error:true, loading:false});
                this.setState({
                    message: "Nous rencontrons actuellement un problème technique. Merci de réessayer ultérieurement."
                });
            }
        );


    }
    onChangeEmail(e) {

        this.setState({
            email: e.target.value,
            resEmail: false,
            message:"",
            error:false,
            cliccaptcha:false,
        });

        if(isEmail(e.target.value)){
            this.setState({
                resEmail: true,
            });
        }else{
            this.setState({
                resEmail: false,
                message:""
            });
        }

    }

    render() {
        return (
            <div className="col-md-12">
                <div className="card card-container">
                    <img
                        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                        alt="profile-img"
                        className="profile-img-card"
                    />

                    <Form
                        ref={c => {
                            this.form = c;
                        }}
                    >
                        <div className="form-group">
                            <label htmlFor="username">Saisir votre adresse email</label>
                            <Input
                                type="text"
                                className="form-control"
                                name="email"
                                value={this.state.email}
                                onChange={this.onChangeEmail}
                                validations={[required, email]}
                            />
                        </div>
                        {( this.state.resEmail && this.state.email) && (
                        <div className="form-group">
                            <ReCAPTCHA
                                sitekey={this.state.KEY_CAPTCHA}
                                onChange={this.onChangeCaptcha}
                                className="g-recaptcha"
                            />
                            {this.state.loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                        </div>
                        )
                        }
                        {(this.state.message) && (
                            <div className="form-group">
                                <div className={!this.state.error ? "alert alert-success": "alert alert-danger"} role="alert">
                                    {this.state.message}
                                </div>
                            </div>
                        )}

                    </Form>
                </div>
            </div>
        );
    }
}

export default withRouter(ChangePassword);